// extracted by mini-css-extract-plugin
export default {"login__input":"login-form_login__input__ZZ8Ya","login__input--mb":"login-form_login__input--mb__I4ayT","login__error":"login-form_login__error__PgzSc"};